/*    
<summary>
  This functional component shows the fota release details.
  Developer:Aashish Singh, Created Date: 04-July-2025
</summary>
<returns>Returns JSX</returns>
*/

import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useStore } from "../../../contexts/StoreProvider";
import { IFotaTenantReleaseList } from "../../../models/response/IFotaResponse";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import FotaStatusEnum from "../../../constants/fota-status-enum";

interface IProps {
  selectedData: IFotaTenantReleaseList;
}

const FotaTenantDetails = (props: IProps) => {
  const { fotaTntReleaseStore, tenantStore } = useStore();
  const {
    GetFotaHostScheduleByIdService,
    getFotaHostScheduleInfo,
    fotaHostScheduleDetailState,
  } = fotaTntReleaseStore;
  const { selectedTenantId } = tenantStore;

  /**
   * This function calls the "GetFotaHostScheduleByIdService" store funtion that get group data from API
   */
  const callGetFotaById = () => {
    GetFotaHostScheduleByIdService(props?.selectedData.Id);
  };

  useEffect(() => {
    if (props?.selectedData.Id > 0) {
      callGetFotaById();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.selectedData.Id]);

  return (
    <React.Fragment>
      {fotaHostScheduleDetailState.inProgress && (
        <FormLoader loading={fotaHostScheduleDetailState.inProgress} />
      )}
      {getFotaHostScheduleInfo && (
        <div className="p-3">
          <div className="row pt-2">
            <div className="col-6">
              <label className="text-muted bold">
                <FormattedMessage id="fota_config_name" />:{" "}
              </label>
            </div>
            <div className="col-6">
              <p className="mw-100">
                <span>{getFotaHostScheduleInfo.ConfigName}</span>
              </p>
            </div>
          </div>
          <div className="row pt-2">
            <div className="col-6">
              <label className="text-muted bold">
                <FormattedMessage id="config_version" />:{" "}
              </label>
            </div>
            <div className="col-6">
              <p className="mw-100">
                <span>{getFotaHostScheduleInfo.ConfigVersion}</span>
              </p>
            </div>
          </div>
          <div className="row pt-2">
            <div className="col-6">
              <label className="text-muted bold">
                <FormattedMessage id="status" />:{" "}
              </label>
            </div>
            <div className="col-6">
              <p className="mw-100">
                <span>{getFotaHostScheduleInfo.IsScheduleAborted === true ? <FormattedMessage id="aborted" /> : <FormattedMessage id={FotaStatusEnum[getFotaHostScheduleInfo.Status]} />}</span>
              </p>
            </div>
          </div>
          <div className="row pt-2">
            <div className="col-6">
              <label className="text-muted bold">
                <FormattedMessage id="progress" />:{" "}
              </label>
            </div>
            <div className="col-6">
              <p className="mw-100">
                <span>{getFotaHostScheduleInfo.Progress} %</span>
              </p>
            </div>
          </div>
          <div className="row pt-2">
            <div className="col-6">
              <label className="text-muted bold">
                <FormattedMessage id="schedule_duration_limit" />:{" "}
              </label>
            </div>
            <div className="col-6">
              <p className="mw-100">
                <span>{getFotaHostScheduleInfo.ScheduleDurationDay}</span>
              </p>
            </div>
          </div>
          {getFotaHostScheduleInfo.Description && (
            <div className="row pt-2">
              <div className="col-6">
                <label className="text-muted bold">
                  <FormattedMessage id={"desc"} />:{" "}
                </label>
              </div>
              <div className="col-6">
                <p className="mw-100">
                  <span>{getFotaHostScheduleInfo.Description}</span>
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default observer(FotaTenantDetails);
